function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#ffce00",
  r: 256
}))))))))), /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0-18.324-1.926-36.199-5.585-53.433l-130.198-130.198-299.217 274.259 87.407 87.407-7.172 5.826 70.607 70.607c9.247 1.012 18.642 1.532 28.158 1.532 141.385 0 256-114.615 256-256z",
  fill: "#ffa300"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m409.082 358.414h-306.164c-19.008 0-34.418-15.409-34.418-34.418v-124.557c0-19.008 15.409-34.418 34.418-34.418h306.164c19.008 0 34.418 15.409 34.418 34.418v124.557c0 19.008-15.409 34.418-34.418 34.418z",
  fill: "#636978"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m409.082 165.021h-152.962v193.393h152.962c19.009 0 34.418-15.409 34.418-34.417v-124.558c0-19.009-15.409-34.418-34.418-34.418z",
  fill: "#414952"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m135.783 312.151h240.434v46.262h-240.434z",
  fill: "#414952"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256.12 312.151h120.097v46.262h-120.097z",
  fill: "#23272b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m135.783 72.369h240.434v136.181h-240.434z",
  fill: "#414952"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256.12 72.369h120.097v136.181h-120.097z",
  fill: "#23272b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m320.032 137.179h-128.064c-11.748 0-21.272-9.524-21.272-21.272v-43.538h170.608v43.538c0 11.748-9.524 21.272-21.272 21.272z",
  fill: "#555a66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256.12 72.369v64.81h63.911c11.748 0 21.272-9.524 21.272-21.272v-43.538z",
  fill: "#333940"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m101.249 274.56h309.502v25.663h-309.502z",
  fill: "#555a66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256.12 274.56h154.63v25.663h-154.63z",
  fill: "#333940"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 116.201,
  cy: 245.004,
  fill: "#64e1dc",
  r: 14.952
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 155.744,
  cy: 245.004,
  fill: "#64e1dc",
  r: 14.952
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m157.235 312.151h197.53v127.71h-197.53z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256.12 312.151h98.645v127.71h-98.645z",
  fill: "#e9edf5"
})));

var SvgPrinter = function SvgPrinter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printer.5d467c2a.svg";
export { ForwardRef as ReactComponent };